import ErrorAlert from '@/assets/images/ErrorAlert.svg';
import SuccessAlert from '@/assets/images/SuccessAlert.svg';
import { useAppDispatch, useAppSelector } from '@/hooks/store';
import { ToastAlertType, hideToast } from '@/state/toast';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Box, Close, Flex, Text, ThemeUICSSObject } from 'theme-ui';

const containerStyles: ThemeUICSSObject = {
  position: 'fixed',
  top: '33px',
  right: '10px',
  backgroundColor: 'neutralLight',
  border: '1px solid #E6E2DA',
  boxShadow: '0px 0px 10px rgba(196, 196, 196, 0.5)',
  borderRadius: '8px',
  zIndex: 999,
};

const headerCSS: ThemeUICSSObject = {
  color: 'neutralDark',
  fontSize: '1',
  lineHeight: '0',
  fontWeight: 'bold',
};

const contentCSS: ThemeUICSSObject = {
  color: 'secondaryText',
  fontSize: '1',
  lineHeight: '1',
  fontWeight: 'semibold',
};

const closeButtonCSS: ThemeUICSSObject = {
  fontSize: '2',
  fontWeight: 'bold',
  bg: 'transparent',
  color: 'neutralDark',
  cursor: 'pointer',
};

const contentColorMap: Record<ToastAlertType, string> = {
  [ToastAlertType.SUCCESS]: 'secondaryText',
  [ToastAlertType.ERROR]: 'secondaryLabel',
};

const alertImageMap: Record<ToastAlertType, string> = {
  [ToastAlertType.SUCCESS]: SuccessAlert,
  [ToastAlertType.ERROR]: ErrorAlert,
};

const ToastNotification = () => {
  const { isVisible, alertType, header, content, action, duration } =
    useAppSelector((state) => state.toast);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isVisible || !duration) {
      return undefined;
    }
    const timeoutId = window.setTimeout(() => {
      dispatch(hideToast());
    }, duration);
    return () => window.clearTimeout(timeoutId);
  }, [dispatch, duration, isVisible]);

  contentCSS.color = contentColorMap[alertType];
  return isVisible ? (
    <Alert sx={containerStyles}>
      <Box>
        <Flex sx={{ gap: 2, alignItems: 'center' }}>
          <img src={alertImageMap[alertType]} />
          <Box sx={{ py: 2 }}>
            <Text sx={headerCSS}>{header}</Text>
            {content && (
              <Box sx={{ mt: 1 }}>
                <Text sx={contentCSS}>{content}</Text>
              </Box>
            )}
          </Box>
          <Close sx={closeButtonCSS} onClick={() => dispatch(hideToast())} />
        </Flex>
        {action && (
          <Box sx={{ pl: '28px', pb: 2 }}>
            <Link
              to={action.href}
              sx={{
                color: 'secondaryText',
                fontSize: 1,
                fontWeight: 'semibold',
                textDecoration: 'underline',
              }}
              onClick={() => dispatch(hideToast())}
            >
              {action.label}
            </Link>
          </Box>
        )}
      </Box>
    </Alert>
  ) : null;
};

export default ToastNotification;
